import { z } from "zod";

export enum AppNotificationType {
  // Authentication
  AUTH_WELCOME = "AUTH_WELCOME",

  // User Engagement
  IMAGE_LIKE = "IMAGE_LIKE",
  IMAGE_COMMENT = "IMAGE_COMMENT",
  NEW_FOLLOWER = "NEW_FOLLOWER",
  FOLLOWING_IMAGE_UPLOAD = "FOLLOWING_IMAGE_UPLOAD",
  WINK = "WINK",
}

export type AppNotificationImageLikeData = {
  imageId: string;
  likeId: string;
};

export const AppNotificationImageLikeDataSchema = z.object({
  imageId: z.string(),
  likeId: z.string(),
});

export type AppNotificationImageCommentData = {
  imageId: string;
  commentId: string;
};

export const AppNotificationImageCommentDataSchema = z.object({
  imageId: z.string(),
  commentId: z.string(),
});

export type AppNotificationWinkData = Record<string, never>;

export const AppNotificationWinkDataSchema = z.object({});

export type NoAppNotificationData = Record<string, never>;

export const NoNotificationDataSchema = z.object({}).strict();

export type AppNotificationData =
  | AppNotificationImageLikeData
  | AppNotificationImageCommentData
  | AppNotificationWinkData
  | NoAppNotificationData;

export const AppNotificationDataSchema = z.union([
  AppNotificationImageLikeDataSchema,
  AppNotificationImageCommentDataSchema,
  AppNotificationWinkDataSchema,
  NoNotificationDataSchema,
]);

export type AppNotification = {
  id: string;
  type: AppNotificationType;
  data: AppNotificationData;
};

export const AppNotificationSchema = z
  .object({
    id: z.string(),
    type: z.nativeEnum(AppNotificationType),
    data: AppNotificationDataSchema,
  })
  .refine(
    (data) => {
      switch (data.type) {
        case AppNotificationType.IMAGE_LIKE:
          return AppNotificationImageLikeDataSchema.safeParse(data.data)
            .success;
        case AppNotificationType.IMAGE_COMMENT:
          return AppNotificationImageCommentDataSchema.safeParse(data.data)
            .success;
        case AppNotificationType.AUTH_WELCOME:
          return NoNotificationDataSchema.safeParse(data.data).success;
        case AppNotificationType.WINK:
          return AppNotificationWinkDataSchema.safeParse(data.data).success;
        default:
          return false;
      }
    },
    {
      message: "Invalid data for the given app notification type",
      path: ["data"],
    },
  );
